import * as S from './styles'
import { RootStateCarteira } from '../../../../store/carteiraReducer';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { formatToBRL } from 'base/src/utils/mathUtil';
import StateMensage from 'base/src/view/states/state';
import { CARTEIRA_BASE_GET } from 'domain/types/_carteira/carteiraBase/carteiraBase';
import { Icon } from '@iconify/react';
import { useTheme } from 'base/src/utils/context/themeContext';

const connector = connectUtil(
  (state: RootStateCarteira) => ({
    homeInfo: state.CarteiraBaseReducer.CarteiraBase,
    CarteiraUsuario: state.CarteiraBaseReducer.CarteiraUsuario,
  }),
  {  }
);

export interface CarteiraHomeComponentProps extends PropsFromRedux<typeof connector> {
}

function PrimaryCard (props: CarteiraHomeComponentProps) {
  const { theme } = useTheme();

  return (
    <S.Container>
      {
        props.homeInfo !== null &&
        <>
          <S.TextContainer>
            <S.ContainerSubtitle>
              <S.IconBadge color={theme.colors.primary}>
                <Icon icon="ph:wallet-bold" height={20} />
              </S.IconBadge>
              <S.Title>Saldo Atual</S.Title>
              <S.Value>{props.homeInfo.EsconderSaldo ? "R$ *****,**" : formatToBRL(props.homeInfo.BalancoAtual || 0)}</S.Value>
            </S.ContainerSubtitle>

          <S.ContainerSubtitle>
            <S.Subtitle>Saldo em Processamento</S.Subtitle>
            <S.SecondaryValue>{props.homeInfo.EsconderSaldo ? "R$ *****,**" : formatToBRL(props.homeInfo.SaldoBloqueado || 0)}</S.SecondaryValue>
          </S.ContainerSubtitle>

          </S.TextContainer>
          <StateMensage stateLoadingNames={[CARTEIRA_BASE_GET]} stateErrorNames={[CARTEIRA_BASE_GET]} />
        </>
      }
    </S.Container>
  )
}

export default connector(PrimaryCard);
